import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from '../styles/vipCard.module.scss'
import { useAssetImage } from '@/platforms/utils'
import  vipImagePaths from '../vipImagePaths.json'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { Swiper as SwiperType } from 'swiper'

import { EffectCoverflow } from 'swiper/modules';
import { useTranslation } from 'react-i18next'
import { useVipCfgList, useVipPromotionList } from '../hooks/useVip'
import { useModal } from '@/modals/modalContext'

const VipCard = ({gradeData}) => {
  const { t } = useTranslation('vip')
  const { openModal } = useModal()
  const { memberGradeConfigList: ConfigList, memberInfoChangeList: changeList } = gradeData || {}
  const [grade, setGrade] = useState(0)

  const { lines , cards } = vipImagePaths
  const imageLines = useAssetImage(lines, {theme: true})
  const imageCards = useAssetImage(cards, {theme: true})
  const arrowRight = useAssetImage('vip-card-arrow-right', {theme: true})
  const arrowLeft = useAssetImage('vip-card-arrow-left',{ theme: true})
  const lineLeft = useAssetImage('vip-title-line-left',{ theme: true})
  const lineRight= useAssetImage('vip-title-line-right',{ theme: true})
  const levelUpReward = useAssetImage('vip-level-upReward',{ theme: true})
  const monthlyBonus = useAssetImage('vip-monthly-bonus',{ theme: true})

  // VIP尊享
  const privilegeList = useMemo(()=>{
    return [
      {
        privilegeIcon: levelUpReward,
        privilege_n: ConfigList?.[grade]?.dayWithdrawalCounts,
        privilege_t: t('vipCard.dailyWithdrawCount')
      },
      {
        privilegeIcon: levelUpReward,
        privilege_n: ConfigList?.[grade]?.dayWithdrawalMoney,
        privilege_t: t('vipCard.dailyWithdrawLimit')
      },
      {
        privilegeIcon: levelUpReward,
        privilege_n: ConfigList?.[grade]?.upgradeBonus,
        privilege_t: t('vipCard.levelUpReward'),
        // tip: t('vipCard.manualLevelUpClaim')
      },
      {
        privilegeIcon: levelUpReward,
        privilege_n: ConfigList?.[grade]?.birthCash,
        privilege_t: t('vipCard.birthdayGift')
      },
      {
        privilegeIcon: monthlyBonus,
        privilege_n: ConfigList?.[grade]?.weekGift,
        privilege_t: t('vipCard.weeklyBonus')
      },
    ]
  },[ConfigList,grade])
  
  // 晋级优惠
  const { data: configData, isLoading } = useVipPromotionList(`${grade}`) 
  const upbonusList = useMemo (()=>{
    return [
      {
        upbonus_n: configData?.rules?.[0]?.minTransferAmount,
        upbonus_t: t('vipCard.minimumTransfer')
      },
      {
        upbonus_n: configData?.rules?.[0]?.dividendRate != null
        ? `${configData.rules[0].dividendRate}%`
        : '',
        upbonus_t: t('vipCard.bonusRate')
      },
      {
        upbonus_n: configData?.rules?.[0]?.bonusLimitAmount,
        upbonus_t: t('vipCard.maximumBonus')
      },
      {
        upbonus_n: configData?.rules?.[0]?.flowRequirements,
        upbonus_t: t('vipCard.turnoverMultiplier')
        // upbonus_r: '倍'
      },
      {
        upbonus_n: configData?.rules?.[0]?.cycleName,
        upbonus_t: t('vipCard.limitPerTimes')
      },
      {
        upbonus_n: t('vipCard.specificVenue'),
        upbonus_t: t('vipCard.gameVenue')
      },
    ]
  },[configData])

  // card卡片
  const cardList = useMemo(()=>{
    if (!ConfigList) return []
    const arr = [...ConfigList]
    // arr.shift()
    return arr
  },[ConfigList])

  const swiperRef = useRef<SwiperType | null>(null)
  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }
  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <div className={styles.vip_card}>
      <div>
        <div className={styles.top}>
          <img src={imageLines[0]} alt="" />
          <div>VIP{grade}</div>
        </div>

        {/* card */}
        <div className={styles.middle}>
          <div className={styles.vip_arrow} onClick={handlePrev}>
            <img src={arrowLeft} alt="" />
          </div>

          <div className={styles.card_swiper}>
            <Swiper
              effect={'coverflow'}
              loop={true}
              grabCursor={true}
              spaceBetween={-260}
              initialSlide={grade}
              // onSlideChange={(swiper) => setGrade(swiper.activeIndex)}
              onSlideChange={(swiper) => setGrade(swiper.realIndex)}
              centeredSlides={true}
              slidesPerView={2.5}
              coverflowEffect={{
                rotate: 0,       // 旋转角度，0 表示不旋转
                stretch: 0,    // 拉伸值，负值使左右间距更紧密
                depth: 100,      // 透视深度，增加可以让前后景层次更明显
                modifier: 1,     // 影响深度和旋转的系数
                scale: 0.7,      // 这里调整 scale 控制左右 item 的缩放比例
                slideShadows: false // 关闭阴影
              }}
              modules={[EffectCoverflow]}
              className="mySwiper"
              onSwiper={(swiper) => {
                swiperRef.current = swiper // 🔥 关键赋值
              }}
            >
              {cardList?.map((v,index)=>{
                return <SwiperSlide key={index} className={styles.card_item}>
                  <div className={styles.card} style={{ backgroundImage: `url(${imageCards?.[index]})`,backgroundSize: '100% auto'}}>
                    <div className={styles.cart_content}>
                      <div>
                        <span>{t('vipCard.validFlow')} </span> 
                        <span>{(Number(ConfigList?.[index]?.upgradeFlows) || 0).toFixed(2)}</span>
                      </div>
                      <div>
                        <span>{t('vipCard.keepLevelFlow')} </span> 
                        <span>{(Number(ConfigList?.[index]?.relegateFlows) || 0).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              })}
            </Swiper>
          </div>

          <div className={styles.vip_arrow} onClick={handleNext}>
            <img src={arrowRight} alt="" />
          </div>
        </div>
        {/* VIP尊享/晋级优惠 */}
        <div className={styles.bottom}>
          <div className={styles.privileges}>
            <div className={styles.privileges_title}>
              <img src={lineLeft} alt="" />
              <div>VIP{grade}{t('vipCard.privilege')}</div>
              <img src={lineRight} alt="" />
            </div>
            <div className={styles.privileges_content}>
              {privilegeList.map((v,index)=>{
                return <div key={index}>
                  <img src={v.privilegeIcon} alt="" />
                  <div className={styles.content_t}>
                    <div>{v.privilege_n}</div>
                    <div>{v.privilege_t}</div>
                  </div>
                </div>
              })}
            </div>
          </div>

          <div className={styles.upbonus}>
            <div className={styles.upbonus_title}>
              <div>levelUp Bonus</div>
              <div>VIP{grade}{t('vipCard.levelUpBonus')}</div>
            </div>
            <div className={styles.upbonus_content}>
              {upbonusList.map((v,index)=>{
                return <div key={index}>
                  <div className={styles.content_t}>
                    <div>{v.upbonus_n}</div>
                    <div>{v.upbonus_t}</div>
                  </div>
                </div>
              })}
            </div>
          </div>
        </div>
      </div>
    </div>  
  )
}

export default VipCard
